import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { MindshareComponentDataDto } from 'app/client-core/dtos/mindshare-component.model';
import { ExpensesManagmentService } from 'app/client-core/services/expenses-managment.service';
import { ValidationMessage } from 'app/validation';

@Component({
  selector: 'app-expenses-mindshare-modal',
  templateUrl: './expenses-mindshare-modal.component.html',
  styleUrls: ['./expenses-mindshare-modal.component.scss']
})
export class ExpensesMindShareComponent implements OnInit, OnChanges {
  ready = false;
  public validationMessages: ValidationMessage;
  @Input() componentId: number;
  componentData: MindshareComponentDataDto[];

  constructor(
    private expensesService: ExpensesManagmentService,
  ) {
    
  }

  ngOnInit(): void {
    
  }

  getComponentData() {
    this.ready = false;
    this.expensesService.getMindShareComponent(this.componentId).subscribe(response => {
      if (!response.hasError) {
        this.componentData = response.data;
        this.ready = true;
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    
  }

  updateMindshare(invoiceId, selected: boolean) {
    this.expensesService.updateMindShareComponent(this.componentId, invoiceId, selected).subscribe(response => {
      if (!response.hasError) {
        this.componentData = response.data;
        this.ready = true;
        this.validationMessages = new ValidationMessage(null, true, "Invoice updated").isSuccess();
      } else {
        this.validationMessages = new ValidationMessage(null, true, "Unable to Update Invoice Assignment").isDanger();
      }
    }, error => {
      this.validationMessages = new ValidationMessage(null, true, "Unable to Update Invoice Assignment").isDanger();
    });
  }

  closeModal() {
    location.reload();
    // this.clear();
    // this.layoutService.hideSideModal.next();
  }

  
}



// WEBPACK FOOTER //
// ./src/app/shared/expenses-modal/expenses-mindshare-modal.component.ts